import { combineReducers } from 'redux';
import { routerReducer as routing } from "react-router-redux";
import Payments from './reducers/payments';

export default combineReducers({
  routing,
  Payments,
});
